<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">



        <small class="label ml-0 mb-8">Legislative status (as defined by Regulation (EC) No 1334/2008)</small>


        <vs-table :data="form.legislative_status_item"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container mb-8 mt-8">
          <template slot="thead">
            <vs-th style="font-weight: normal" width="30%">Name</vs-th>
            <vs-th style="font-weight: normal" width="20%">Status</vs-th>
            <vs-th style="font-weight: normal" width="50%">Comment</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"   :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{legislative_status_item_display_names[indextr]}}
              </vs-td>
              <vs-td :data="data[indextr].legislative_is_status">
                <ValidationProvider :vid="indextr+'legislative_is_status'" :name="indextr+'legislative_is_status'" rules="" v-slot="{ errors }">
                  <vs-switch v-model="data[indextr].is_status" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>
              <vs-td :data="data[indextr].legislative_comment">
                <ValidationProvider v-if="data[indextr].is_status" :vid="indextr+'legislative_comment'" :name="indextr+'legislative_comment'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr].comment" name="comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>

        <!--        <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
        <!--        <div v-for="(legislative, index) in form.legislative_status_item" :key="index">-->
        <!--          <div class="vx-row mb-3">-->
        <!--            <div class="vx-col md:w-2/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index+'legislative_name'" :name="index+'legislative_name'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Name</small>-->
        <!--                <vs-input type="text" v-model="legislative.name" name="name" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 md:mb-0">-->
        <!--              <ValidationProvider :vid="index+'legislative_is_status'" :name="index+'legislative_is_status'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Status</small>-->
        <!--                <vs-switch v-model="legislative.is_status" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
        <!--                  <span slot="on">Yes</span>-->
        <!--                  <span slot="off">No</span>-->
        <!--                </vs-switch>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-2/5 w-full md:mb-0">-->
        <!--              <ValidationProvider v-if="legislative.is_status" :vid="index+'legislative_comment'" :name="index+'legislative_comment'" rules="required" v-slot="{ errors }">-->
        <!--                <small class="label">Comment</small>-->
        <!--                <vs-input type="text" v-model="legislative.comment" name="comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
        <!--        </div>-->


        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_others" name="is_others" rules="" v-slot="{ errors }">
              <small class="label">Others?</small>
              <vs-switch v-model="form.is_others" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>

        <div v-if="form.is_others" v-for="(other, index) in form.is_others_legislative" :key="index">
          <div class="vx-row mb-3" >
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider :vid="index+'other_name'" :name="index+'other_name'" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="other.name" type="text" name="name" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider :vid="index+'other_comment'" :name="index+'other_comment'" rules="required" v-slot="{ errors }">
                <small class="label">Comment</small>
                <vs-input v-model="other.comment" type="text" name="comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <small class="label">&nbsp;</small>
              <vs-button :disabled="form.is_others_legislative.length === 1" class="" @click="deleteOtherName(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
            </div>
          </div>
        </div>
        <vs-button v-if="form.is_others" @click="addOtherName" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add Other Name</vs-button>

        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <ValidationProvider vid="label_declaration" name="label_declaration" rules="" v-slot="{ errors }">
              <small class="label">Recommended labelling declaration:
              </small>
              <vs-textarea v-model="form.label_declaration" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>


        <div class="vx-row mb-8 mt-4">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_compliant_flavouring" name="is_compliant_flavouring" rules="" v-slot="{ errors }">
              <small class="label">Compliant with Regulation (EC) No 1334/2008 on flavourings and certain food ingredients with flavouring properties for use in and on foods ?</small>
              <vs-switch v-model="form.is_compliant_flavouring" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_compliant_flavouring" vid="is_compliant_flavouring_comment" name="is_compliant_flavouring_comment" rules="required" v-slot="{ errors }">
              <small class="label">Comment If Yes</small>
              <vs-input type="text" v-model="form.is_compliant_flavouring_comment" name="is_compliant_flavouring_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <small v-if="form.legislative_status_item[0].is_status || form.legislative_status_item[1].is_status" class="label mt-16 mb-2">If Natural Flavouring Substance or Flavouring Substance:</small>

        <div class="vx-row mb-3 mt-2" v-if="form.legislative_status_item[0].is_status || form.legislative_status_item[1].is_status">
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider  vid="minimum_purity" name="minimum_purity" rules="required" v-slot="{ errors }">
              <small class="label">Minimum Purity</small>
              <vs-input type="text" v-model="form.minimum_purity" name="minimum_purity" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3" v-if="form.legislative_status_item[0].is_status || form.legislative_status_item[1].is_status">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_compliant_commission" name="is_compliant_commission" rules="" v-slot="{ errors }">
              <small class="label">Compliant with Commission Regulation (EU) No 872/2012 (Union List of flavouring substances) ?</small>
              <vs-switch v-model="form.is_compliant_commission" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_compliant_commission" vid="is_compliant_commission_comment" name="is_compliant_commission_comment" rules="required" v-slot="{ errors }">
              <small class="label">Comment If Yes</small>
              <vs-input type="text" v-model="form.is_compliant_commission_comment" name="is_compliant_commission_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-if="!isCompleted" @click.stop="onClickMarkAsComplete" class="ml-4 mt-2" type="border" color="warning">Mark As Complete</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import RawMaterialForm from "@/mixins/RawMaterialForm";

  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const SupplierRepository = RepositoryFactory.get('supplier');


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        chips:[
          'Dribbble',
          'GitHub',
          'Behance',
          'Vuejs',
          'Vuexy',
        ],
        form: {
          legislative_status_item: [
            {
              name: "natural_flavouring",
              is_status: false,
              comment: ""
            },
            {
              name: "flavouring_substance",
              is_status: false,
              comment: ""
            },
            {
              name: "flavouring_preparation",
              is_status: false,
              comment: ""
            },
            {
              name: "smoke_flavouring",
              is_status: false,
              comment: ""
            }
          ],
          is_others_legislative: [
            {name: '', comment: ''}
          ],
          is_others: false,
          is_compliant_flavouring: false,
          is_compliant_commission: false
        },
        id: null,
        status: {},
        legislative_status_item_display_names: [
          'Natural Flavouring Substance', 'Flavouring Substance', 'Flavouring Preparation', 'Smoke Flavouring',
          'Other (please specify)'
        ],
      }
    },
    props : {
      isCompleted: { default: false },
    },
    mixins: [SuccessMessage, ErrorMessages, RawMaterialForm],
    methods: {
      remove (item) {
        this.chips.splice(this.chips.indexOf(item), 1)
      },
      onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickMarkAsComplete() {
        this.$emit('mark-as-complete', 'is_raw_material_legislative_status_marked_completed')
      },
      onClickSubmit() {
        this.status.is_raw_material_legislative_status_complete ? this.$mixinsOpenUpdateConfirm() : this.onClickCreate()
      },

      async onClickUpdate() {
        this.$vs.loading()
        try {
          if (!this.form.is_others) {
            this.form.is_others_legislative = []
          }
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialLegislative(this.id, this.form))
          this.showSuccessMessage('Raw Material Legislative Status Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          if (!this.form.is_others) {
            this.form.is_others_legislative = []
          }
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialLegislative(this.form))
          this.showSuccessMessage('Raw Material Legislative Status Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialLegislative(this.id)).data
        this.form = data
        if (this.form.is_others_legislative.length === 0) {
          this.addOtherName()
        }
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      addOtherName() {
        this.form.is_others_legislative.push(
          {name: '', comment: ''}
        )
      },
      deleteOtherName(index) {
        this.form.is_others_legislative.splice(index, 1)
      }

    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_legislative_status_complete) {
        await this.loadData()
      }
    }
  }
</script>

<style scoped>

</style>
